import axios from 'axios'
import getHeaders from '../helpers/headers'
import config from '../../constants/endpoints.js'
const {
  endpoints: { countries: url },
} = config

const get = () => axios.get(url, { headers: getHeaders(true) })

export default { get }
